import { lerp } from "../../utils/math.js";

export class PointerController {
  constructor() {
    this.target = { x: 0, y: 0 };
    this.current = { x: 0, y: 0 };

    window.addEventListener("pointermove", (event) => {
      this.target.x = (event.clientX / window.innerWidth) * 2 - 1;
      this.target.y = -(event.clientY / window.innerHeight) * 2 + 1;
    });
  }

  update() {
    this.current.x = lerp(this.current.x, this.target.x, 0.08);
    this.current.y = lerp(this.current.y, this.target.y, 0.08);
    return this.current;
  }
}
